import { tryOnMounted as s } from "../node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
import { inject as u, onBeforeUnmount as d, getCurrentInstance as t, reactive as f, provide as p } from "vue";
const i = Symbol("Children tracker provide/inject symbol");
function g(o) {
  const n = f([]);
  return p(o || i, {
    register: (e) => n.push(e),
    unregister: (e) => {
      const r = n.findIndex((c) => c === e);
      r >= 0 && n.splice(r, 1);
    }
  }), n;
}
function x(o, n) {
  const e = u(o || i, null);
  return e && (s(() => {
    if (n !== void 0) {
      e.register(n);
      return;
    }
    const r = t();
    r != null && r.proxy && e.register(r.proxy);
  }), d(() => {
    if (n !== void 0) {
      e.unregister(n);
      return;
    }
    const r = t();
    r != null && r.proxy && e.unregister(r.proxy);
  })), e;
}
export {
  g as provideChildrenTracker,
  x as useChildrenTracker
};
